import React from "react";
import {store} from "./store";
import {DeviceInterface} from "./androidInterface"

class Location extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            location: {
                ID: 0,
                children: []
            },
            count: 0,
            rank: 0
        }
    }

    updateLocation = async () => {
        var locations = []

        const children = store.getState()?.children || []; // Safe check

        for (const location of children) {
            locations.push(location);
        }

        locations.sort((a, b) => b.scans - a.scans);

        for (let i = 0; i < locations.length; i++) {
            if(locations[i].ID === this.props.location.ID){
                this.setState({rank: i + 1})
                break
            }
        }
    }

    componentDidMount() {
        store.subscribe(async () => {
            await this.updateLocation()
        })

        this.updateLocation()

    }

    render() {
        var rank = 0
        var locations = []
        const children = store.getState()?.children || []; // Safe check

        for (const location of children) {
            locations.push(location);
        }

        locations.sort((a, b) => b.scans - a.scans);

        for (let i = 0; i < locations.length; i++) {
            if(locations[i].ID === this.props.location.ID){
                rank = i + 1
                break
            }
        }
        return (
            <div style={{display: this.props.show? "block" : "none"}}>
            <header>

                <div className={"container"}>
                    <img
                        src={`https://${this.props.host}/api/devices/${this.props.deviceToken}/logo`}
                        alt={"Logo"} style={{maxWidth: "60%", maxHeight: "90px"}}/>
                    <p>

                            <svg style={{height: "18px", marginBottom: "-2px"}} xmlns="http://www.w3.org/2000/svg"
                                 height="24px" viewBox="0 -960 960 960" width="24px"
                                 fill="#011589">
                                <path
                                    d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 400Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z"/>
                            </svg>



                        {this.props.location.name !== "undefined" ? this.props.location.name : this.props.deviceToken}
                    </p>
                </div>
                <div style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    display: this.props.isOnline ? "none" : "block"
                }} onClick={DeviceInterface.openNetworkSettings}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                         fill="#d6d4d4">
                        <path
                            d="M790-56 414-434q-47 11-87.5 33T254-346l-84-86q32-32 69-56t79-42l-90-90q-41 21-76.5 46.5T84-516L0-602q32-32 66.5-57.5T140-708l-84-84 56-56 736 736-58 56Zm-310-64q-42 0-71-29.5T380-220q0-42 29-71t71-29q42 0 71 29t29 71q0 41-29 70.5T480-120Zm236-238-29-29-29-29-144-144q81 8 151.5 41T790-432l-74 74Zm160-158q-77-77-178.5-120.5T480-680q-21 0-40.5 1.5T400-674L298-776q44-12 89.5-18t92.5-6q142 0 265 53t215 145l-84 86Z"/>
                    </svg>
                </div>
            </header>

        <section className={"content"}>
            <div id="scan">
                <div className={"container"}>
                    <div className={"holder"}>
                        <h2>Scan Me</h2>
                        <div className={"qr"}>
                            <img
                                src={`https://${this.props.host}/api/devices/${this.props.deviceToken}/${this.props.location.ID}/qr`}
                                alt="" style={{borderRadius: "5px", height: "250px"}}/>
                        </div>
                        <h3 style={{paddingBottom: "0px"}}>Monthly Scans</h3>
                        <p className="ms" style={{
                            marginBottom: "0px",
                            color: this.props.company !== undefined ? (this.props.location.scans < this.props.company.baseline ? "#c25e68" : "") : ""
                        }}>{this.props.location.scans}</p>
                        <hr style={{margin: "0px"}}/>
                        <h3 style={{paddingBottom: "0px", paddingTop: "30px"}}>Rank</h3>
                        <p className="rank">#{this.props.idx === 0? this.props.rank : rank} {/*this.props.idx === 0? "Prop Rank": "State Rank"*/}</p>

                    </div>
                </div>
            </div>
        </section>
        </div>
    );
    }


}

export default Location